import {
  ActivateAccountDto,
  AuthenticateApiUserDto,
  ChangePasswordDto,
  ContactUsDto,
  CreateOrganizationUserDto,
  ForgotPasswordBase,
  IRequestConfig,
  IRequestOptions,
  LoginData,
  Recipient,
  ResetPasswordDto,
  SendActivationEmailDto,
  ShApiResponse_AuthenticateApiUser,
  ShApiResponse_Boolean,
  ShApiResponse_FullSmartheartUser,
  //ShApiResponse_GetCountryCodesDto,
  ShApiResponse_GetGeneralDetailsDto,
  ShApiResponse_GetUserDto,
  ShApiResponse_GetUserEcgsDto,
  ShApiResponse_IEnumerable_GetUserDto,
  ShApiResponse_IEnumerable_SmartheartUser,
  ShApiResponse_List_GetBasicUserDto,
  ShApiResponse_List_GetOrganizationDomainDto,
  ShApiResponse_SmartheartUser,
  ShApiResponse_TreeView_TreeViewNodeDto,
  SmartheartUser,
  UpdateMeDto,
  UpdatePasswordDto,
  UpdateUserDto,
  UserActivationData,
  axios,
  axiosResponse,
  basePath,
  getConfigs,
} from "./index.defs";

export class UsersApiService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
 * Determine if the given email allowed to restore password
<returns>
true is the given email allowed to restore password, otherwise false
</returns><response code="200"></response><response code="400">Invalid request format</response><response code="401">Authentication failed</response>
 */
  static usersGetIsAllowedToRestorePassword(
    params: {
      /**  */
      email: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{email}/password";
      url = url.replace("{email}", params["email"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Authenticates a user
   */
  static usersLogin(
    params: {
      /** The username (email) and password of the user to authenticate */
      credentials: LoginData;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_FullSmartheartUser> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/login";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["credentials"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  static authenticateApiUser(
    params: {
      /**  */
      credentials: AuthenticateApiUserDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_AuthenticateApiUser> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/auth";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["credentials"];

      configs.data = data;
      axiosResponse(configs, resolve, reject);
    });
  }
  /**
   *
   */
  /**
 * Gets the list of users in the logged api user organization.
Requires Api User or admin role authorization.
 */
  static usersGetUsers(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_SmartheartUser> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a new professional organization user. API users only
   */
  static usersCreateUser(
    params: {
      /** The user object to add */
      user: SmartheartUser;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_SmartheartUser> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["user"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets the list of physician users which the logged in user allowed to view
   */
  static usersGetPhysicianUsers(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_GetBasicUserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/physicians";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * Gets the list of users in the logged user organization.
Requires Api User or admin role authorization.
 */
  static usersGetUsersExtended(
    params: {
      /** Filter by the role id of the user. Excluding will result in all roles */
      roleIds: number[];
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetUserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/ex";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = { roleIds: params["roleIds"] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a new user for an organization. The created user needs to be validated and/or activated
   */
  static usersCreateOrganizationUser(
    params: {
      /** The user object to add */
      user: CreateOrganizationUserDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetUserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/organization";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["user"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Activates a given user based on a valid activation token and sets the given password to the activated user.
   */
  static usersActivateUser(
    params: {
      /**  */
      activationData: UserActivationData;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/activate";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["activationData"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Enables a user. API users only
   */
  static usersEnableUser(
    params: {
      /** The unique identifier of the user to enable */
      userId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/status";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Disables the given user. API users only
   */
  static usersDisableUser(
    params: {
      /** The unique identifier of the user */
      userId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/status";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "delete",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Updates the given user. API users only
   */
  static usersUpdateUser(
    params: {
      /** The unique identifier of the user to update */
      userId: string;
      /** The user data to update */
      user: SmartheartUser;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_SmartheartUser> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["user"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Updates the given user
   */
  static usersUpdateUserEx(
    params: {
      /** The unique identifier of the user to update */
      userId: string;
      /** The user data to update */
      user: UpdateUserDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetUserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/ex";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["user"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * Gets the list of ECGs to be viewed in the portal in a given date range of the permissions of the authenticated user.
Admins need canViewEcgs permission
 */
  static usersGetPortalEcgList(
    params: {
      /** The unique identifier of the user whose portal ecg list should be returned */
      userId: string;
      /** The results "page" number to return */
      page?: number;
      /** The number of result in each "page" */
      pageSize?: number;
      /** Free text search term */
      search?: string;
      /** If true then only unviewed ecgs will be returned */
      unviewedOnly?: boolean;
      /** If true then only unInterpreted ECGs will be returned sorted by time remaining to SLA */
      unInterpretedOnly?: boolean;
      /** If false then archived ECGs will be filtered */
      includeArchived?: boolean;
      /** Filter by the device serial number */
      sn?: string;
      /** The date from which to return the ECGs (yyyy-MM-dd) */
      fromDate?: string;
      /** The date until which to return the ECGs (yyyy-MM-dd) */
      toDate?: string;
      /** How to sort the returned ecgs list ("name" - by the account name, ascending; "last-ecg" - by the ecg date/time, descending */
      sort?: string;
      /** The unique identifier of Ecg profile, could be MRN or Reference */
      uniqueId?: string;
      /** access token */
      authorization?: string;
      pageAmount?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetUserEcgsDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/ecgs";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        page: params["page"],
        pageSize: params["pageSize"],
        search: params["search"],
        unviewedOnly: params["unviewedOnly"],
        unInterpretedOnly: params["unInterpretedOnly"],
        includeArchived: params["includeArchived"],
        sn: params["sn"],
        fromDate: params["fromDate"],
        toDate: params["toDate"],
        sort: params["sort"],
        uniqueId: params["uniqueId"],
        pageAmount: params["pageAmount"]
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Adds an additional email recipient for new ECG notifications
   */
  static usersAddRecipients(
    params: {
      /** The unique identifier of the user to add an additional recipient to */
      userId: string;
      /** The recipient email address */
      recipient: Recipient;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/recipients";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["recipient"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Removes an email recipient for new ECG notifications
   */
  static usersDeleteRecipient(
    params: {
      /** The unique identifier of the user to remove the recipient from */
      userId: string;
      /** The recipient email address to remove */
      recipient: Recipient;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/recipients";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "delete",
        "application/json",
        url,
        options
      );

      let data = params["recipient"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Reset user password. Only by admin users.
   */
  static usersResetUserPassword(
    params: {
      /** The unique identifier of the user to change password for */
      userId: string;
      /** The new password to set */
      passwordDto: UpdatePasswordDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/password";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["passwordDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Sends a support request to customer service.
   */
  static usersContactUs(
    params: {
      /**  */
      contactUsDto: ContactUsDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/me/help";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["contactUsDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Changes the authenticated user's password.
   */
  static usersChangePassword(
    params: {
      /**  */
      passwordDto: ChangePasswordDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/me/password";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["passwordDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Update the authenticated user's personal info.
   */
  static usersUpdateMe(
    params: {
      /**  */
      updateMeDto: UpdateMeDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetUserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/me";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["updateMeDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Send a forget password request.
   */
  static usersForgotPassword(
    params: {
      /**  */
      forgotPasswordDto: ForgotPasswordBase;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/v2/users/forgot-password";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["forgotPasswordDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Send password reset from an email that was received by the user
   */
  static usersResetPasswordFromEmail(
    params: {
      /**  */
      resetPasswordDto: ResetPasswordDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/password";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["resetPasswordDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Send an activation email to the user
   */
  static usersSendActivationEmail(
    params: {
      /**  */
      activationEmailDto: SendActivationEmailDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/activation";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["activationEmailDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Activate the given user's account
   */
  static usersActivateAccount(
    params: {
      /**  */
      activateAccountDto: ActivateAccountDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/account-activation";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["activateAccountDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get a list of permitted domains for the given user
   */
  static usersGetOrganizationPermittedDomains(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_GetOrganizationDomainDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/domain";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets all entities/users under the given organization in a tree structure
   */
  static usersGetTreeView(
    params: {
      /** true will return all profiles, false will filter the archived */
      includeArchived?: boolean;
      /** The date from which to return the ECGs (yyyy-MM-dd) */
      ecgFromDate?: string;
      /** The date until which to return the ECGs (yyyy-MM-dd) */
      ecgToDate?: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_TreeView_TreeViewNodeDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/tree-view";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        includeArchived: params["includeArchived"],
        ecgFromDate: params["ecgFromDate"],
        ecgToDate: params["ecgToDate"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Save user agreement on terms of use
   */
  static usersSaveTermsOfUseAgreement(
    params: {
      /**  */
      userId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/terms-of-use";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns main menu information for the authenticated user.
   */
  static usersGetGeneralDetails(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetGeneralDetailsDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/main-menu";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

  //UNCOMMENT IF COUNTRY CODES WILL BE SENT FROM SERVER
  // static getCountryCodes(
  //   options: IRequestOptions = {}
  // ): Promise<ShApiResponse_GetCountryCodesDto> {
  //   return new Promise((resolve, reject) => {
  //     let url = basePath + "/get-country-codes"; //TODO change url once server is ready

  //     const configs: IRequestConfig = getConfigs(
  //       "get",
  //       "application/json",
  //       url,
  //       options
  //     );

  //     let data = null;

  //     configs.data = data;
  //     axios(configs, resolve, reject);
  //   });
  // }
}
